import { useRouter } from 'next/router';
import { type FC, useEffect } from 'react';
import { ModalLogin } from '@/Module/Auth/Component';
import { checkRubikaToken, checkShadToken, isGuid } from '@/Module/Auth/Helper';
import { useLogin } from '@/Module/Auth/Hook';
import type { IAuth } from '@/Module/Auth/Model/DataModel';
import { authSetIsTransitioningAction } from '@/Module/Auth/Store/Slice/AuthSlice';
import { LINKS } from '@/Module/Core/Constant';
import { hasHappened } from '@/Module/Core/Helper';
import { CookieService } from '@/Module/Core/Service';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
import { getSubscriptionsV2UserAction } from '@/Module/Subscription/Store/Action';
const STORAGE_KEY = 'messenger_auth';
const AuthMessengerContainer: FC = () => {
  const router = useRouter();
  const {
    loginViaMessenger
  } = useLogin();
  const dispatch = useAppDispatch();
  const rubikaToken = useAppSelector(state => state.auth.rubikaToken);
  const shadToken = useAppSelector(state => state.auth.shadToken);
  useEffect(() => {
    if (hasHappened(STORAGE_KEY, 5, 5) || !rubikaToken || rubikaToken.length !== 50) return;
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    const orderId = router.query?.orderId as string || '';
    const status = router.query?.st as string || '';
    if (orderId || status) return;
    CookieService.setRubikaToken(rubikaToken);
    dispatch(authSetIsTransitioningAction(true));
    checkRubikaToken(dispatch, {
      token: rubikaToken
    }).then(result => {
      if (result?.type === 'JWT') {
        loginViaMessenger(result.value as IAuth).then(() => {
          dispatch(getSubscriptionsV2UserAction(result.value.accessToken)).unwrap().then(list => {
            const plan = list.data.find(item => item?.subscriptionPlanId === 199);
            if (!plan || !plan.endDate) {
              router.push(LINKS.SUBSCRIPTION.RUBIKA);
              return;
            }
            const now = new Date();
            const endDate = new Date(plan!.endDate);
            if (endDate >= now) {
              router.push(LINKS.LEARNING);
              return;
            }
            router.push(LINKS.SUBSCRIPTION.RUBIKA);
          });
        });
      }
      if (result?.type === 'NOT_REGISTERED') {
        router.push(LINKS.SUBSCRIPTION.RUBIKA);
      }
    });
  }, [rubikaToken]);
  useEffect(() => {
    if (hasHappened(STORAGE_KEY, 5, 5) || !shadToken || !isGuid(shadToken)) return;
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    CookieService.setShadToken(shadToken);
    checkShadToken(dispatch, {
      token: shadToken
    }).then(result => {
      if (result?.type === 'JWT') {
        loginViaMessenger(result.value as IAuth);
      }
      if (result?.message?.includes('503')) {
        router.push({
          pathname: LINKS.AUTH.SHAD_LOGOUT,
          query: {
            result: '503'
          }
        });
      }
    });
  }, [shadToken]);
  return <ModalLogin data-sentry-element="ModalLogin" data-sentry-component="AuthMessengerContainer" data-sentry-source-file="AuthMessengerContainer.tsx" />;
};
export default AuthMessengerContainer;